'use strict';

var Backbone = require('backbone');
var _ = require('lodash');
var getQueryParamByName = require('tscom-util/src/getQueryParamByName');
var managerSingleton = null;

function CMSManager (){
    var cmsList = [];

    // Simple count of all CMS objects in the system
    this.count = function() {
        return cmsList.length;
    };

    // This is called automatically by every CMS object
    // created, and should never need to be called manually
    this.add = function (cms) {
        var manager = this;
        function eventHandler(model){
            manager.trigger('change', model);
        }
        this.listenTo(cms,'change',eventHandler);
        cmsList.push(cms);
    };

    // Returns all CMS objects with the given widget ID,
    // or if widget ID is not set, returns all tracked
    // CMS objects.
    this.get = function(wid) {
        if(typeof wid !== 'string') {
            return cmsList.slice();
        }
        var retList = [];
        for(var i = 0; i < cmsList.length; i ++) {
            if(cmsList[i].get('wid') == wid) {
                retList.push(cmsList[i]);
            }
        }
        return retList;
    }

    // Allows an individual CMS object to be removed from
    // the system.  Use this when the CMS object is destroyed.
    // Stops listening to this object's events.  Boolean
    // return for whether the CMS object existed to begin with.
    this.remove = function(cms) {
        for(var i = 0; i < cmsList.length; i ++) {
            if(cms === cmsList[i]) {
                this.stopListening(cms);
                cmsList.splice(i,1);

                // There should only ever be one instance
                // of this object in the array, so return
                // now
                return true;
            }
        }
        return false;
    };

    // Remove all CMS objects from the system. Stops listening
    // to all objects.
    this.clear = function() {
        var tempList = cmsList.slice();
        for(var i = 0; i < tempList.length; i ++) {
            this.remove(tempList[i]);
        }
    };
};

managerSingleton = new CMSManager();
_.extend(managerSingleton, Backbone.Events);

var TSComCMS = Backbone.Model.extend({

    defaults: {
        /**
         * Where to pull the data from.
         * Different servers have different needs / capabilities.  Like caching.
         */
        apiUrl: 'https://widgetstate.votenow.tv/v1/state/',
        /**
         * The widget ID to retrieve.
         * Should be found in the URL Query String Parameter or hardcoded in 'initialize()'
         */
        wid: 'data/data.json', // default template widget
        /**
         * The etag.
         * to access the cdn's etag cache
         */
        etag: null,
        /**
         * The snapshot ID (if necessary).
         * Should be found in the URL Query String Parameter
         */
        sid: null,
        useSID: null,
        /**
         *  Timestamp of widget
         */
        ts: null,
        /**
         * Window Status, abstracted from the widget 'settings' key
         */
        windowStatus: null,
        /**
         * Widget Text
         */
        text: {},
        /**
         * Widget Settings
         */
        settings: {},
        /**
         * Widget CSS
         */
        css: {},
        /**
         * Widget Data: Vote Options, Poll and Trivia Questions, Mood Buttons
         */
        data: [],
        /**
         * Social Configuration: Facebook and Twitter app and share info
         */
        social: {},
        /**
         * All data from CMS API
         */
        raw: {},
        /**
         * The number of seconds to wait before updating again.
         */
        updateFrequency: 30,
        /**
         *
         */
        pollTimer: null,
        /**
         *
         */
        initialized: false
    },

    /**
     * enable polling?
     */
    poll: true,

    /**
     * [initialize description]
     * @param  {Object} attrs   [description]
     * @param  {Object} options [description]
     */
    initialize: function(attrs, options) {
        managerSingleton.add(this);

        var wid = ((getQueryParamByName('wid').length === 0 || options.ignoreQSP) ? undefined : getQueryParamByName('wid')) || attrs.wid || this.defaults.wid,
            sid = ((getQueryParamByName('sid').length === 0 || options.ignoreQSP) ? undefined : getQueryParamByName('sid')) || attrs.sid || this.defaults.sid,
            useSID = (!_.isNull(sid)) ? sid : null; // Force the Cms to use a specific Snapshot ID from Connect's CMS

        // console.log('CmsModel initialize', wid, sid, useSID);
        if (typeof options === 'object') {
            for (var prop in options) {
                if (typeof this[prop] !== 'undefined') {
                    this[prop] = options[prop];
                }
            }
        }

        this.set({
            wid: wid,
            useSID: useSID
        });
    },

    /**
     * Builds the URL to fetch data from the Connect API
     * @return {[type]} [description]
     */
    urlRoot: function() {
        var url = (
            this.get('wid').search(/\//) === -1 ?
            // If there is a numeric wid provided, then use the base
            // url and query for that particular id.
            this.get('apiUrl') + '/' + this.get('wid') + (!_.isNull(this.get('useSID')) ? '/snapshot/' + this.get('useSID') : '')
            // Otherwise, get the file specified by the wid field, i.e. '/test/cms/widget_data.php'
            : this.get('wid') + '?' + Math.random()
        );
        return url;
    },

    /**
     * [sync description]
     * @param  {[type]} crud    [description]
     * @param  {[type]} model   [description]
     * @param  {Object} options [description]
     * @return {[type]}         [description]
     */
    sync: function(crud, model, options) {
      var params = {
          url: this.urlRoot(),
          type: 'GET',
          dataType: 'json',
          crossDomain: true
      };
      var etag = this.get('etag');
      if(etag){
          options.beforeSend = function(xhr) {
              xhr.setRequestHeader('if-none-match', etag);
          };
      }
      _.extend(params, options);

      this.xhr = Backbone.sync(crud, model, params);

      return this.xhr;
    },


    /**
     * [save description]
     * @param  {Object} attrs   [description]
     * @param  {Object} options [description]
     */
    save: function(attrs, options) {
        console.warn('The CMS model does not support "save"');
    },

    /**
     * [destroy description]
     * @param  {Object} options [description]
     */
    destroy: function(options) {
        console.warn('The CMS model does not support "destroy"');
    },

    /**
     * [requestData description]
     * @param  {Object} options [description]
     */
    requestData: function(options) {
        this.fetch(options);
    },

    fetch: function(options) {
        if (this.poll) {
            this.pollData();
        }
        //changed to return to return the sync, useful for calling .done() after
        return Backbone.Model.prototype.fetch.call(this, options);
    },


    parse: function(data, option) {
        if( data === undefined ) {
          return undefined;
        }

        var parsedData = _.extend({}, {
          initialized: true,
          raw: data, // Update full CMS output

          metadata: {
            current_timestamp: data.current_timestamp,
            snapshot_start_timestamp: data.snapshot.schedule,
            name: data.snapshot.name,
          },

          sid: data.snapshot.snapshot_id,
          data: data.snapshot.data.data,
          settings: data.snapshot.data.settings,
          social: data.snapshot.data.social,
          text: data.snapshot.data.text,
          windowStatus: parseInt(data.snapshot.data.settings.window_status),
          ts: data.current_timestamp,
          etag: this.xhr.getResponseHeader('etag')
        });

        return parsedData;
    },

    /**
     * Sets the polling timer
     */
    pollData: function() {
        clearTimeout(this.get('pollTimer'));

        this.set({
            pollTimer: setTimeout(_.bind(this.fetch, this), parseInt(this.get('updateFrequency'), 10) * 1000)
        });
    },

    /**
     * Stop polling and clear the timer
     */
    stopPolling: function() {
        this.poll = false;
        var pollTimer = this.get('pollTimer');
        if(typeof pollTimer == 'number') clearTimeout(pollTimer);
        this.set('pollTimer', null);
    }
});

module.exports = TSComCMS;
module.exports.manager = managerSingleton;
